import React, { useContext, Suspense } from "react";
import { AuthContext } from "../context/AuthProvider";
import { Route, Switch, useLocation } from "react-router-dom";
import Spinner from "../components/Spinner";
import { MainLayout, EditorLayout, ModalLayout } from "../layouts";
import { AdminRoute, GuestRoute } from "./permissions";
import { RoutesAdmin, RoutesMain, RoutesAuth, RoutesLanding } from "./routes";

export const modalPaths = ["/signup", "/signin", "/reset", "/set-password"];
// Following https://github.com/xavivzla/multi-layout-react-router-v5 for basic structure
export const AppRouter = () => {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const isModalPath = modalPaths.some(mp => location.pathname.startsWith(mp));
  // When on a modal path, render the browse page behind the modal overlay.
  // Use the background location from state if available (e.g., when navigating from browse),
  // otherwise create a location object pointing to "/" for direct navigation to auth routes.
  const locationToUse = isModalPath
    ? (location.state?.background ?? { pathname: '/', search: '', hash: '' })
    : location;

  // preload indeterminite spinner
  if (user === null || user === undefined || user.role === "loading") {
    return <Spinner />;
  }
  return (
    <Suspense fallback={<Spinner />}>
      <Switch location={locationToUse}>
        {/* Admin Routes (user.adminUser only) */}
        <AdminRoute path="/admin">
          <MainLayout showPlayer={false}>
            <RoutesAdmin root="/admin" />
          </MainLayout>
        </AdminRoute>

        {/* Landing Page Routes (authenticated and guest) */}
        <Route path="/landing">
          <EditorLayout drawerMask={false} drawerMaskClosable={false}>
            <RoutesLanding root="/landing" />
          </EditorLayout>
        </Route>

        {/* Main Site Routes (authenticated and guest) */}
        <Route path="/">
          <MainLayout>
            <RoutesMain />
          </MainLayout>
        </Route>
      </Switch>
      {/* Authentication Routes (guest users only) */}
      <GuestRoute path={modalPaths}>
        <ModalLayout>
          <Suspense fallback={<Spinner />}>
            <RoutesAuth />
          </Suspense>
        </ModalLayout>
      </GuestRoute>
    </Suspense>
  );
};
